/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AdminUserMenuResponse } from '../model';
// @ts-ignore
import { AdminUserMenuSelectionResponse } from '../model';
// @ts-ignore
import { CreateUserMenuSelectionByAdminRequest } from '../model';
// @ts-ignore
import { MealSelectionsByTypeResponse } from '../model';
// @ts-ignore
import { UpdateUserMenuSelectionByAdminRequest } from '../model';
// @ts-ignore
import { UserMenuStatusResponse } from '../model';
/**
 * AdminUserMenuControllerApi - axios parameter creator
 * @export
 */
export const AdminUserMenuControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignUnselectedMenus: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/user-menu/unselected`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {CreateUserMenuSelectionByAdminRequest} createUserMenuSelectionByAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSelectionByAdmin: async (userId: string, createUserMenuSelectionByAdminRequest: CreateUserMenuSelectionByAdminRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('createSelectionByAdmin', 'userId', userId)
            // verify required parameter 'createUserMenuSelectionByAdminRequest' is not null or undefined
            assertParamExists('createSelectionByAdmin', 'createUserMenuSelectionByAdminRequest', createUserMenuSelectionByAdminRequest)
            const localVarPath = `/admin/user-menu/{userId}/selections`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserMenuSelectionByAdminRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {string} [userId] 
         * @param {string} [dietitianId] 
         * @param {string} [affiliateId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDeliveryPackagesReport: async (date: string, userId?: string, dietitianId?: string, affiliateId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('downloadDeliveryPackagesReport', 'date', date)
            const localVarPath = `/admin/user-menu/delivery-packages-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (dietitianId !== undefined) {
                localVarQueryParameter['dietitianId'] = dietitianId;
            }

            if (affiliateId !== undefined) {
                localVarQueryParameter['affiliateId'] = affiliateId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMenuStatusesByDate: async (userId: string, startDate: string, endDate: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getMenuStatusesByDate', 'userId', userId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getMenuStatusesByDate', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getMenuStatusesByDate', 'endDate', endDate)
            const localVarPath = `/admin/user-menu/{userId}/dates`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSelectionsByPortion: async (date: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getSelectionsByPortion', 'date', date)
            const localVarPath = `/admin/user-menu/selections/portions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserMenuByUserAndDate: async (userId: string, date: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserMenuByUserAndDate', 'userId', userId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getUserMenuByUserAndDate', 'date', date)
            const localVarPath = `/admin/users/{userId}/user-menu`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} selectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSelectionByAdmin: async (userId: string, selectionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeSelectionByAdmin', 'userId', userId)
            // verify required parameter 'selectionId' is not null or undefined
            assertParamExists('removeSelectionByAdmin', 'selectionId', selectionId)
            const localVarPath = `/admin/user-menu/{userId}/selections/{selectionId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"selectionId"}}`, encodeURIComponent(String(selectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} selectionId 
         * @param {UpdateUserMenuSelectionByAdminRequest} updateUserMenuSelectionByAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSelectionByAdmin: async (userId: string, selectionId: string, updateUserMenuSelectionByAdminRequest: UpdateUserMenuSelectionByAdminRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateSelectionByAdmin', 'userId', userId)
            // verify required parameter 'selectionId' is not null or undefined
            assertParamExists('updateSelectionByAdmin', 'selectionId', selectionId)
            // verify required parameter 'updateUserMenuSelectionByAdminRequest' is not null or undefined
            assertParamExists('updateSelectionByAdmin', 'updateUserMenuSelectionByAdminRequest', updateUserMenuSelectionByAdminRequest)
            const localVarPath = `/admin/user-menu/{userId}/selections/{selectionId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"selectionId"}}`, encodeURIComponent(String(selectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserMenuSelectionByAdminRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatusById: async (id: string, body: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateStatusById', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateStatusById', 'body', body)
            const localVarPath = `/admin/user-menu/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminUserMenuControllerApi - functional programming interface
 * @export
 */
export const AdminUserMenuControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminUserMenuControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignUnselectedMenus(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignUnselectedMenus(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {CreateUserMenuSelectionByAdminRequest} createUserMenuSelectionByAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSelectionByAdmin(userId: string, createUserMenuSelectionByAdminRequest: CreateUserMenuSelectionByAdminRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUserMenuSelectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSelectionByAdmin(userId, createUserMenuSelectionByAdminRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} date 
         * @param {string} [userId] 
         * @param {string} [dietitianId] 
         * @param {string} [affiliateId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadDeliveryPackagesReport(date: string, userId?: string, dietitianId?: string, affiliateId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadDeliveryPackagesReport(date, userId, dietitianId, affiliateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMenuStatusesByDate(userId: string, startDate: string, endDate: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserMenuStatusResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMenuStatusesByDate(userId, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSelectionsByPortion(date: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MealSelectionsByTypeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSelectionsByPortion(date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserMenuByUserAndDate(userId: string, date: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUserMenuResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserMenuByUserAndDate(userId, date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} selectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeSelectionByAdmin(userId: string, selectionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeSelectionByAdmin(userId, selectionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} selectionId 
         * @param {UpdateUserMenuSelectionByAdminRequest} updateUserMenuSelectionByAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSelectionByAdmin(userId: string, selectionId: string, updateUserMenuSelectionByAdminRequest: UpdateUserMenuSelectionByAdminRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSelectionByAdmin(userId, selectionId, updateUserMenuSelectionByAdminRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStatusById(id: string, body: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStatusById(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminUserMenuControllerApi - factory interface
 * @export
 */
export const AdminUserMenuControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminUserMenuControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignUnselectedMenus(options?: any): AxiosPromise<void> {
            return localVarFp.assignUnselectedMenus(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {CreateUserMenuSelectionByAdminRequest} createUserMenuSelectionByAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSelectionByAdmin(userId: string, createUserMenuSelectionByAdminRequest: CreateUserMenuSelectionByAdminRequest, options?: any): AxiosPromise<AdminUserMenuSelectionResponse> {
            return localVarFp.createSelectionByAdmin(userId, createUserMenuSelectionByAdminRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} date 
         * @param {string} [userId] 
         * @param {string} [dietitianId] 
         * @param {string} [affiliateId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDeliveryPackagesReport(date: string, userId?: string, dietitianId?: string, affiliateId?: string, options?: any): AxiosPromise<File> {
            return localVarFp.downloadDeliveryPackagesReport(date, userId, dietitianId, affiliateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMenuStatusesByDate(userId: string, startDate: string, endDate: string, options?: any): AxiosPromise<Array<UserMenuStatusResponse>> {
            return localVarFp.getMenuStatusesByDate(userId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSelectionsByPortion(date: string, options?: any): AxiosPromise<Array<MealSelectionsByTypeResponse>> {
            return localVarFp.getSelectionsByPortion(date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserMenuByUserAndDate(userId: string, date: string, options?: any): AxiosPromise<AdminUserMenuResponse> {
            return localVarFp.getUserMenuByUserAndDate(userId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} selectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSelectionByAdmin(userId: string, selectionId: string, options?: any): AxiosPromise<void> {
            return localVarFp.removeSelectionByAdmin(userId, selectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} selectionId 
         * @param {UpdateUserMenuSelectionByAdminRequest} updateUserMenuSelectionByAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSelectionByAdmin(userId: string, selectionId: string, updateUserMenuSelectionByAdminRequest: UpdateUserMenuSelectionByAdminRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateSelectionByAdmin(userId, selectionId, updateUserMenuSelectionByAdminRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatusById(id: string, body: string, options?: any): AxiosPromise<void> {
            return localVarFp.updateStatusById(id, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminUserMenuControllerApi - object-oriented interface
 * @export
 * @class AdminUserMenuControllerApi
 * @extends {BaseAPI}
 */
export class AdminUserMenuControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserMenuControllerApi
     */
    public assignUnselectedMenus(options?: AxiosRequestConfig) {
        return AdminUserMenuControllerApiFp(this.configuration).assignUnselectedMenus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {CreateUserMenuSelectionByAdminRequest} createUserMenuSelectionByAdminRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserMenuControllerApi
     */
    public createSelectionByAdmin(userId: string, createUserMenuSelectionByAdminRequest: CreateUserMenuSelectionByAdminRequest, options?: AxiosRequestConfig) {
        return AdminUserMenuControllerApiFp(this.configuration).createSelectionByAdmin(userId, createUserMenuSelectionByAdminRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} date 
     * @param {string} [userId] 
     * @param {string} [dietitianId] 
     * @param {string} [affiliateId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserMenuControllerApi
     */
    public downloadDeliveryPackagesReport(date: string, userId?: string, dietitianId?: string, affiliateId?: string, options?: AxiosRequestConfig) {
        return AdminUserMenuControllerApiFp(this.configuration).downloadDeliveryPackagesReport(date, userId, dietitianId, affiliateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserMenuControllerApi
     */
    public getMenuStatusesByDate(userId: string, startDate: string, endDate: string, options?: AxiosRequestConfig) {
        return AdminUserMenuControllerApiFp(this.configuration).getMenuStatusesByDate(userId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} date 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserMenuControllerApi
     */
    public getSelectionsByPortion(date: string, options?: AxiosRequestConfig) {
        return AdminUserMenuControllerApiFp(this.configuration).getSelectionsByPortion(date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {string} date 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserMenuControllerApi
     */
    public getUserMenuByUserAndDate(userId: string, date: string, options?: AxiosRequestConfig) {
        return AdminUserMenuControllerApiFp(this.configuration).getUserMenuByUserAndDate(userId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {string} selectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserMenuControllerApi
     */
    public removeSelectionByAdmin(userId: string, selectionId: string, options?: AxiosRequestConfig) {
        return AdminUserMenuControllerApiFp(this.configuration).removeSelectionByAdmin(userId, selectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {string} selectionId 
     * @param {UpdateUserMenuSelectionByAdminRequest} updateUserMenuSelectionByAdminRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserMenuControllerApi
     */
    public updateSelectionByAdmin(userId: string, selectionId: string, updateUserMenuSelectionByAdminRequest: UpdateUserMenuSelectionByAdminRequest, options?: AxiosRequestConfig) {
        return AdminUserMenuControllerApiFp(this.configuration).updateSelectionByAdmin(userId, selectionId, updateUserMenuSelectionByAdminRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserMenuControllerApi
     */
    public updateStatusById(id: string, body: string, options?: AxiosRequestConfig) {
        return AdminUserMenuControllerApiFp(this.configuration).updateStatusById(id, body, options).then((request) => request(this.axios, this.basePath));
    }
}

